import styled from 'styled-components';
import LinkOperationCard from '../../Cards/LinkOperationCard';

export const CustomLinkOperationCard = styled(LinkOperationCard)``;

export const CustomOperationContainer = styled.div`
  overflow: hidden !important;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 1.2rem;
`;
